import { render, staticRenderFns } from "./OrgProfile.vue?vue&type=template&id=e45a4c5a&scoped=true"
import script from "./OrgProfile.vue?vue&type=script&lang=js"
export * from "./OrgProfile.vue?vue&type=script&lang=js"
import style0 from "./OrgProfile.vue?vue&type=style&index=0&id=e45a4c5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45a4c5a",
  null
  
)

export default component.exports